export const extractHtml = (data, term) => {
  const html = data.find(o => o.id === term);
  return html?.value;
};
